<div *ngIf="control.errors && ((control.invalid && control.touched) || control.dirty)">
  <small class="form-error-text">
    <ng-template
      [ngTemplateOutlet]="
        control.errors.required ? required :
        control.errors.whitespaces ? whitespaces :
        control.errors.specialChars ? specialChars :
        control.errors.email ? email :
        control.errors.minlength ? minlength :
        control.errors.componentWithNameExists ? componentWithNameExists :
        control.errors.min ? min :
        control.errors.max ? max :
        control.errors.endDateLowerThanStartDate ? endDateLowerThanStartDate :
        empty
      "
      #message
    ></ng-template>
  </small>

  <ng-template #required>
    {{'invalid.required' | transloco}}
  </ng-template>
  <ng-template #specialChars>
    {{'invalid.specialChars' | transloco}}
  </ng-template>
  <ng-template #whitespaces>
    {{'invalid.whitespaces' | transloco}}
  </ng-template>
  <ng-template #email>
    {{'invalid.email' | transloco}}
  </ng-template>
  <ng-template #minlength>
    {{'invalid.minLength' | transloco: { requiredLength: control.errors.minlength.requiredLength } }}
  </ng-template>
  <ng-template #componentWithNameExists>
    {{'invalid.componentWithNameExists' | transloco}}
  </ng-template>
  <ng-template #min>
    {{'invalid.min' | transloco: { min: control.errors.min.min} }}
  </ng-template>
  <ng-template #max>
    {{'invalid.max' | transloco: { max: control.errors.max.max} }}
  </ng-template>
  <ng-template #endDateLowerThanStartDate>
    {{'invalid.endDateLowerThanStartDate' | transloco}}
  </ng-template>
  <ng-template #empty></ng-template>
</div>
